const release = '0.13.8'

module.exports = { release }



// WEBPACK FOOTER //
// ./release.js